import React from "react";
import { withRouter, Switch, Route } from "react-router-dom";

import Homepage from "./containers/Homepage";
import Search from "./containers/Search";
import Navbar from "./containers/Navbar";
import Church from "./containers/Church";
import ShortStory from "./containers/ShortStory";
import ShortStories from "./containers/ShortStories";
import Article from "./containers/Article";
import Articles from "./containers/Articles";
import Page from "./containers/Page";
import PageHeader from "./components/PageHeader";
import Footer from "./containers/Footer";
import App from "./containers/App";
import witchTracker from "./withTracker";

const Routing = ({ location }) => {
    const currentKey = location.pathname.split("/")[1] || "/";
    const pageClass = currentKey === "/" ? "home" : currentKey;
    const showPageHeader = ["/", "sok"].includes(currentKey);

    return (
        <App id={`page-${pageClass}`}>
            <Navbar />
            {/* Some global fetching goes on in Navbar */}
            {showPageHeader && <PageHeader currentPath={currentKey} />}
            <Switch location={location}>
                <Route path="/" exact component={witchTracker(Homepage)} />
                <Route path="/sok" component={witchTracker(Search)} />
                <Route path="/kirke/:id" component={witchTracker(Church)} />
                <Route
                    path="/historier/:id"
                    component={witchTracker(ShortStory)}
                />
                <Route
                    path="/historier"
                    component={witchTracker(ShortStories)}
                />
                <Route path="/artikler/:id" component={witchTracker(Article)} />
                <Route path="/artikler" component={witchTracker(Articles)} />
                <Route path="/page/:id" component={witchTracker(Page)} />
            </Switch>
            <Footer currentKey={currentKey} />
        </App>
    );
};

export default withRouter(Routing);



// WEBPACK FOOTER //
// ./src/Routing.js